import { Routes } from '../config/routes'

import { AdminGuard } from '../guards'
import type { RouteConfig } from '../types'

import { OrganizationList } from '../../containers/Admin/Organization'
import { OrganizationDetail } from '../../containers/Admin/Organization/detail'
import { PropertyList } from '../../containers/Admin/Property/list'
import { PropertyDetail } from '../../containers/Admin/Property/detail'
import { UserList } from '../../containers/Admin/User'
import { UserDetail } from '../../containers/Admin/User/detail'
import { InvoiceListPage } from '../../containers/Admin/Invoice'
import { InvoiceDetail } from '../../containers/Admin/Invoice/detail'
import { VendorList } from '../../containers/Admin/Vendor'
import { VendorDetail } from '../../containers/Admin/Vendor/detail'
import { AdminSchoolsList } from '../../containers/Admin/Schools'
import { AdminLayout } from '../layouts/AdminLayout'
import { LoriManager } from '../../components/AdminPanel/Lori Manager/LoriManager'
import { SupportTicketHome } from '../../containers/SupportTicket/SupportTicketHome'
import { KPIHome } from '../../containers/KPI/KpiHome'
import { AdminFormsRoot } from '../../containers/Admin/Forms/AdminFormsRoot'
import AdminReportHome from '../../containers/Admin/Reports/AdminReportHome'
import { BillingGroupHome } from '../../containers/Admin/BillingGroup/BillingGroupHome'
import { OutreachHome } from '../../containers/Admin/Outreach/OutreachHome'
import { ApplicationAccessHome } from '../../containers/Admin/ApplicationAccess/ApplicationAccessHome'
import { OnboardApartmentPage } from '../../containers/Admin/OnboardApartment/OnboardApartmentPage'
import { CopyConfigsPage } from '../../containers/Admin/CopyConfigs/CopyConfigsPage'
import { WorkspaceManagerPage } from '../../containers/Admin/WorkspaceManager/WorkspaceManagerPage'
import { BannerNotificationsPage } from '../../containers/Admin/BannerNotifications/BannerNotificationsPage'

export const adminRoutes: RouteConfig[] = [
    {
        path: Routes.admin.organization.detail.root,
        component: OrganizationDetail,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.organization.list,
        component: OrganizationList,
        layout: AdminLayout,
        guard: AdminGuard,
    },

    {
        path: Routes.admin.properties.detail,
        component: PropertyDetail,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.properties.root,
        component: PropertyList,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.users.detail,
        component: UserDetail,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.users.root,
        component: UserList,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.vendors.detail,
        component: VendorDetail,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.vendors.root,
        component: VendorList,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.schools.root,
        component: AdminSchoolsList,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.invoices.detail,
        component: InvoiceDetail,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.invoices.root,
        component: InvoiceListPage,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.billingGroups,
        component: BillingGroupHome,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.loriManager,
        component: LoriManager,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.supportTicket,
        component: SupportTicketHome,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.kpi,
        component: KPIHome,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.forms,
        component: AdminFormsRoot,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.reports,
        component: AdminReportHome,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.outreach,
        component: OutreachHome,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.applicationAccess,
        component: ApplicationAccessHome,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.onboardApartment,
        component: OnboardApartmentPage,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.copyConfigs,
        component: CopyConfigsPage,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.workspaceManager,
        component: WorkspaceManagerPage,
        layout: AdminLayout,
        guard: AdminGuard,
    },
    {
        path: Routes.admin.bannerNotifications,
        component: BannerNotificationsPage,
        layout: AdminLayout,
        guard: AdminGuard,
    },
]
